module.exports = __webpack_public_path__ + "polreg-16eee50edd497b5338183abe5a32fb27.png";